export default function (value) {
	if (value) {
		var year = value.substring(0, 2);
		var month = value.substring(2, 4);
		var day = value.substring(4, 6);
		var hour = value.substring(6, 8);
		var minute = value.substring(8, 10);
		var second = value.substring(10, 12);
		if (hour) {
			return '20'+year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second;
		} else {
			return '20'+year+'-'+month+'-'+day;
		}
	}
}
